// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2BDC-","content":"LoadingAlert_content__HHHuK"};